import React from 'react';
import * as Icons from '@material-ui/icons';
import iconGetUp from '../../../images/Presense/Action/man-stand.svg';
import iconJump from '../../../images/Presense/Action/icon-jump.png';
import iconNoMovement from '../../../images/Presense/Action/icon-nomovement.png';
import iconNosignal from '../../../images/Presense/DeviceSignal/icon-nosignal.png';

export default function Accessibility({ children, ...props }) {
  let result = '';
  switch (children) {
    case 1:
    case 10:
    case 14:
    case 15:
    case 16:
    case 17:
      result = <Icons.LocalHotel style={{ fontSize: 55, color: '#000000' }} />;
      break;
    case 2:
      result = <Icons.AirlineSeatReclineNormal style={{ fontSize: 55 }} />;
      break;
    case 3:
      result = <img src={iconGetUp} alt='getup' width='55' />;
      break;
    case 4:
      result = <Icons.DirectionsWalk style={{ fontSize: 55 }} />;
      break;
    case 5:
      result = <Icons.DirectionsRun style={{ fontSize: 55 }} />;
      break;
    case 6:
      result = <img src={iconJump} alt='jump' width='55' />;
      break;
    case 8:
      result = <Icons.BatteryAlert style={{ fontSize: 55 }} />;
      break;
    case 504:
      result = <img src={iconNosignal} alt='nosignal' width='55' />;
      break;
    case 11:
      result = <img src={iconNoMovement} alt='nomovement' width='55' />;
      break;
    case 18:
      result = <Icons.TransferWithinAStation style={{ fontSize: 55 }} />;
      break;
    case 19:
      result = <Icons.DirectionsWalk style={{ fontSize: 55 }} />;
      break;
    case 100:
      result = <Icons.LocationOn style={{ fontSize: 55 }} />;
      break;
    // case 101:
    //   result = <Icons.NotificationsActive style={{ fontSize: 55 }}/>;
    //   break;
    default:
      result = <Icons.Help style={{ fontSize: 55 }} />;
      break;
  }
  return result;
}
